export function lang() {
  $('[data-lang]').on('click', function () {
    $(this).next('dd').toggleClass('on');
  });
}
